// extracted by mini-css-extract-plugin
export var assigneeBadge = "_li-0";
export var assigneeDetails = "_li-1";
export var assigneeInfo = "_li-2";
export var dropdownContainer = "_li-4";
export var dropdownImage = "_li-5";
export var editAssigneeInfo = "_li-3";
export var editAssigneeModalContainer = "_li-6";
export var hidden = "_li-8";
export var input = "_li-7";